
import {isDebug} from "../appConfig";

const Logger = {
	print(...data) {
		isDebug && console.log('[WT] => ', ...data)
	}
}

export {
	Logger
}
